


































































































































































































































































































































































































































































































import { i18n } from '@/i18n';
import { compass } from '@resclick/compass';
import { IFile, IProperty } from '@resclick/data-access';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import DateRangeInput from './product-search-date-range.input.vue';
import PeopleInput from './product-search-people.input.vue';
import moment from 'moment';
import { debounce as qDebounce } from 'quasar';

@Component({
  components: {
    PeopleInput,
    DateRangeInput,
  },
})
export default class ProductSearchShell extends Vue {
  @Action('cart/addToCart') addToCart!: (params: any) => void;
  @Action('cart/clearCart') clearCart!: () => void;
  @State('cart') cart!: any;
  @Getter('user/ownedPermissions') permissions!: string;

  availabilityStorage: any = {};

  debounce = qDebounce;

  isAvailableDate(roomId: string, date: string) {
    const key = moment(date, 'YYYY/MM/DD').format('YYYY-MM-DD');
    const data = this.availabilityStorage[roomId]?.[key] || {};

    return data.remaining > 0 && data.isAvailable !== false;
  }

  loadAvailability(propertyId: string, roomId: string) {
    compass
      .do('properties', 'findOneRoomAvailability', {
        params: { propertyId, roomId },
      })
      .then((res) => res.data)
      .then((res) => {
        this.$set(this.availabilityStorage, roomId, res);
      });
  }

  tab = 'offers';
  currentProductIndex = 0;
  isSearched = false;
  isLoading = false;
  form = {
    fields: this.buildQuery(),
  };

  lastQuery = this.buildQuery();

  items: any[] = [];

  propertySearchOptions: any[] = [];

  isDateSelectable(date: string) {
    return moment(date, 'YYYY/MM/DD').isSameOrAfter(new Date(), 'date');
  }

  get dateRange() {
    return {
      start: moment(this.form.fields.checkInDate).format('YYYY-MM-DD'),
      end: moment(this.form.fields.checkOutDate).format('YYYY-MM-DD'),
    };
  }

  set dateRange(value: any) {
    this.form.fields.checkInDate = new Date(moment(value.start).format('YYYY-MM-DD')) as any;
    this.form.fields.checkOutDate = new Date(moment(value.end).format('YYYY-MM-DD')) as any;
  }

  get availabilityRange() {
    return {
      from: moment(this.dateRange.start).format('YYYY/MM/DD'),
      to: moment(this.dateRange.end).format('YYYY/MM/DD'),
    };
  }

  set availabilityRange(value: any) {
    this.form.fields.checkInDate = new Date(moment(value.from, 'YYYY/MM/DD').format('YYYY-MM-DD')) as any;
    this.form.fields.checkOutDate = new Date(moment(value.to, 'YYYY/MM/DD').format('YYYY-MM-DD')) as any;
  }

  get buildQuery() {
    return () => {
      return {
        search: '',
        market: 'TR',
        product: 'HOTEL',
        adults: 2,
        includeUnavailable: true,
        children: [] as number[],
        checkInDate: new Date(moment().format('YYYY-MM-DD')),
        checkOutDate: new Date(moment().add({ days: 7 }).format('YYYY-MM-DD')),
      };
    };
  }

  get getCoordinates() {
    return (product: IProperty) => {
      const coordinates = product?.location?.coordinates || [];
      return {
        lat: coordinates[0] || 0,
        lng: coordinates[1] || 0,
      };
    };
  }

  get currentProduct() {
    let property: any = {};
    if (this.items[this.currentProductIndex]) {
      property = JSON.parse(JSON.stringify(this.items[this.currentProductIndex]));
    }

    if (property) {
      let { rooms = [] } = property;
      const flat: any = [];
      rooms.forEach((room: any) => {
        const { ratePlans = [], ...rest } = room;
        ratePlans?.forEach((ratePlan: any) => {
          flat.push({
            ...rest,
            ratePlan,
          });
        });
      });

      property.rooms = flat;

      property.rooms.sort((a: any, b: any) => {
        return a.ratePlan?.price?.value - b.ratePlan?.price?.value;
      });
    }

    return property;
  }

  get bestOffer() {
    return (property: any) => {
      const { rooms = [] } = property;
      const newArray = [...rooms];
      newArray.sort((a, b) => {
        return a.price?.value - b.price?.value;
      });

      return newArray[0];
    };
  }

  get fullImageURL() {
    return (image?: string) => {
      if (image) {
        return process.env.VUE_APP_CDN_URL + image;
      }
      return '';
    };
  }

  get galleryImages() {
    if (this.currentProduct) {
      const { images = [] } = this.currentProduct;
      return images.map((image: IFile) => {
        const label = image.meta?.category ? i18n.t('AMENITIES.' + image.meta.category) : '';
        return {
          thumbnail: this.fullImageURL(image.sizes?.thumbnail),
          url: this.fullImageURL(image.sizes?.large),
          label: label,
          id: image.id,
        };
      });
    }
    return [];
  }

  get productTypeOptions() {
    return [
      { label: i18n.tc('GENERAL.HOTEL'), value: 'HOTEL' },
      { label: i18n.tc('GENERAL.FLIGHT'), value: 'FLIGHT' },
      { label: i18n.tc('GENERAL.TOUR'), value: 'TOUR' },
      { label: i18n.tc('GENERAL.TRANSFER'), value: 'TRANSFER' },
    ];
  }

  get numberOfGuests() {
    return {
      adults: this.form.fields.adults,
      children: this.form.fields.children,
    };
  }

  set numberOfGuests(value: { adults: number; children: number[] }) {
    this.form.fields.adults = value.adults;
    this.form.fields.children = value.children;
  }

  filterFn(val: string, update: any, abort: any) {
    this.form.fields.search = val;

    if (val.length < 3) {
      abort();
      return;
    }

    compass
      .do('autoCompletions', 'findPropertiesOrPlaces', {
        query: { key: val },
      })
      .then((res) => res.data)
      .then((data) => {
        update(
          () => {
            if (val === '') {
              this.propertySearchOptions = [];
            } else {
              this.propertySearchOptions = data.map((item) => {
                return {
                  label: item.name,
                  value: item.name,
                  type: item.type,
                };
              });
            }
          },
          (ref: any) => {
            if (val !== '' && ref.options.length > 0) {
              ref.setOptionIndex(-1); // reset optionIndex in case there is something selected
              ref.moveOptionSelection(1, true); // focus the first selectable option and do not update the input-value
            }
          },
        );
      });
  }

  abortFilterFn() {
    return;
  }

  getFeaturedImage(product: any) {
    let featuredImage = '';
    if (Array.isArray(product.images)) {
      const img = product.images.find((image: IFile) => image.meta?.isFeaturedImage === true);
      if (img) featuredImage = this.fullImageURL(img.sizes.small);
    }

    return featuredImage;
  }

  getLocation(product: any) {
    const results: string[] = [];
    let out = '';
    if (typeof product.address === 'object') {
      const { country = {}, province = {}, district = {} } = product.address;
      if (country && country.name) results.push(country.name);
      if (province && province.name) results.push(province.name);
      if (district && district.name) results.push(district.name);
      out = results.join(' / ');
    }
    return out;
  }

  getRating(product: { category?: { code?: string } }) {
    let rating = 0;
    if (product.category) {
      switch (product.category.code) {
        case '1STR': {
          rating = 1;
          break;
        }
        case '2STR': {
          rating = 2;
          break;
        }
        case '3STR': {
          rating = 3;
          break;
        }
        case '4STR': {
          rating = 4;
          break;
        }
        case '5STR': {
          rating = 5;
          break;
        }
      }
    }
    return rating;
  }

  cursor: any = null;
  canContinue = false;

  async onProductSearch() {
    this.cursor = null;
    this.canContinue = false;
    this.items = [];
    this.getPrices(this.form.fields);
  }

  getPrices(fields: any) {
    this.isSearched = true;
    this.isLoading = true;

    compass
      .do('prices', 'find', {
        query: {
          market: fields.market,
          adults: fields.adults,
          children: fields.children,
          search: fields.search,
          includeUnavailable: true,
          checkInDate: this.$formatDate(fields.checkInDate, 'YYYY-MM-DD'),
          checkOutDate: this.$formatDate(fields.checkOutDate, 'YYYY-MM-DD'),
          cursor: this.cursor,
        },
        populate: ['category', 'address.country', 'address.province', 'address.district', 'images'],
      })
      .then((res) => {
        this.lastQuery = JSON.parse(JSON.stringify(fields));
        this.items.push(...res.data);
        this.canContinue = !!res?.data?.length;
        this.cursor = res.data[res.data.length - 1].id;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  onPropertyScroll(event: any) {
    const container = event.currentTarget as HTMLDivElement;
    const checkPoint = container.scrollHeight - 10;
    const positonBottom = container.scrollTop + container.getBoundingClientRect().height;

    if (positonBottom > checkPoint && !this.isLoading && this.canContinue) {
      this.getPrices(this.lastQuery);
    }
  }
}
